/**
 *
 * Asynchronously loads the component for ScheduleDemoScheduleDemo
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const ScheduleDemo = lazyLoad(
  () => import('./index'),
  module => module.ScheduleDemo,
);
